import type { BoardGraph } from '@shared/board/graph';
import type { DistanceCache } from '@shared/board/distance-cache';
import type { GameState } from './types';

export interface BoardEntryEffectResult {
  damaged?: boolean;
  blocked?: boolean;
  died?: boolean;
}

export type BoardEntryEffectHandler = (
  state: GameState,
  playerId: string,
  nodeId: string,
  graph?: BoardGraph,
  distanceCache?: DistanceCache,
) => BoardEntryEffectResult | void;

const registry = new Map<string, BoardEntryEffectHandler>();

export function registerBoardEntryEffect(id: string, handler: BoardEntryEffectHandler): void {
  registry.set(id, handler);
}

export function applyBoardEntryEffects(
  state: GameState,
  playerId: string,
  nodeId: string,
  graph?: BoardGraph,
  distanceCache?: DistanceCache,
): BoardEntryEffectResult {
  let damaged = false;
  let blocked = false;
  let died = false;

  for (const handler of registry.values()) {
    const result = handler(state, playerId, nodeId, graph, distanceCache);
    damaged ||= result?.damaged === true;
    blocked ||= result?.blocked === true;
    died ||= result?.died === true;
    if (died) break;
  }

  return { damaged, blocked, died };
}
